// This function gets and returns a the data
// of a country using the countryCode

import { getAllActiveCountries } from "./getAllActiveCountries"

export const getCountry = countryCode => {
  const countries = getAllActiveCountries()
  let activeCountry = []
  countries.map(country => {
    // If the country is active
    if (country.countryCode === countryCode) {
      // Add the object to the list of countries

      activeCountry = country
    }
  })

  return activeCountry
}
